<template>
  <div class="width-100p">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <v-btn depressed large block color="white" class="ma-0" v-on="on">
          Unmark as deceased
        </v-btn>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Unmark as Deceased</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p>
            Are you sure you want to unmark <b>{{ testatorName }}</b> as
            deceased?
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                rounded
                depressed
                :loading="buttonLoading"
                color="primary"
                class="left-edit-btn"
                @click="unmarkAsDeceased()"
              >
                <span>Unmark as deceased</span>
                <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
              </v-btn>

              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                outlined
                color="grey.darken1"
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import { UNMARK_TESTATOR_DECEASED_MUTATION } from '../../../constants/graphql/testators';

  export default {
    name: 'unmarkAsDeceased',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
      referrerRoute: {
        type: String,
        default: 'AdminPage',
      },
      referrerId: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        deceased_date: null,
        successMessage: null,
      };
    },
    computed: {
      testatorName() {
        return this.testator.fullName
          ? this.testator.fullName
          : this.testator.email;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
    methods: {
      unmarkAsDeceased() {
        const id = this.testator.id;
        this.$apollo
          .mutate({
            mutation: UNMARK_TESTATOR_DECEASED_MUTATION,
            variables: {
              id,
            },
          })
          .then(response => {
            if (response.data.deceaseTestatorUndo.success) {
              this.successMessage = 'User successfully unmarked as deceased';
              this.redirect();
            } else {
              this.displayErrorAndCloseDialog();
            }
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      redirect() {
        this.$router.push({
          name: this.referrerRoute,
          params: { id: this.referrerId, successMessage: this.successMessage },
        });
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
